var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MyWorkEntry',{attrs:{"entry":_vm.entry}})
}
var staticRenderFns = []

export { render, staticRenderFns }